import Main from "../components/credit-card-examination/Main";
import { SpaceBetween } from "@cloudscape-design/components-themed";
import { useAuthenticationHook } from "../app/useAuthenticationHook";
import { PERMISSIONS } from "../configs/constants";
/* 
クレカ申請 審査申請回答登録・取得A
 */
const CreditCardExamination = () => {
  //権限制御
  useAuthenticationHook(PERMISSIONS.EXAMINE);

  return (
    <SpaceBetween size="l">
      <Main />
    </SpaceBetween>
  );
};

export default CreditCardExamination;
